import * as z from "zod";

export const getCommerceCloudCartridgeStatus = {
  name: "getCommerceCloudCartridgeStatus" as const,
  input: z.null(),
  output: z.object({
    orderSync: z.object({
      ok: z.boolean(),
      lastOrderAt: z.date().nullable(),
      detail: z.string(),
    }),
    storefrontEmbed: z.object({ ok: z.boolean(), detail: z.string() }),
    /**
     * Null when RedoCoverage-Get didn't answer (no store/site, unreachable, non-200,
     * older cartridge without it, or an unparsable body) — consumers must branch on null.
     */
    coverageFeeController: z
      .object({ ok: z.boolean(), version: z.number(), enabled: z.boolean() })
      .nullable(),
  }),
};
